// DonationMasterDetailsModel.jsx
import React, { useContext } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { DONATION_MASTER } from "../../constant";
import DonationMasterContext from "../../context/DonatoinMasterContext/DonationMasterContext";

const DonationMasterDetailsModel = ({ editHandle }) => {
  const {
    ahoeDataModel,
    setahoeDataModel,
    showDonationMaster: d,
  } = useContext(DonationMasterContext);

  const isInward = d?.type === 1;

  return (
    <Modal
      size="lg"
      isOpen={ahoeDataModel}
      toggle={() => setahoeDataModel(false)}
    >
      <ModalHeader toggle={() => setahoeDataModel(false)}>
        <div className="d-flex align-items-center gap-2">
          <i className="fa fa-file-text-o fs-5 text-primary" />
          <div>
            <div className="fw-medium">Donation master — details</div>
            {d?.accountId && (
              <small className="text-muted">
                ID #DM-{String(d.accountId).padStart(5, "0")}
              </small>
            )}
          </div>
        </div>
      </ModalHeader>

      <ModalBody className="p-3 d-flex flex-column gap-3">
        {/* Type banner */}
        <div
          className={`d-flex align-items-center gap-2 px-3 py-2 rounded ${
            isInward
              ? "bg-success-subtle border border-success"
              : "bg-danger-subtle border border-danger"
          }`}
        >
          <i
            className={`fa ${isInward ? "fa-arrow-circle-down text-success" : "fa-arrow-circle-up text-danger"} fs-5`}
          />
          <span
            className={`fw-medium ${isInward ? "text-success" : "text-danger"}`}
          >
            {isInward ? "Inward donation" : "Outward donation"}
          </span>
          <span className="ms-auto text-muted small">
            {isInward ? "Money / goods received" : "Money / goods disbursed"}
          </span>
        </div>

        {/* Basic info */}
        <div className="border rounded">
          <div className="px-3 py-2 border-bottom bg-light">
            <small className="text-uppercase text-muted fw-medium ls-1">
              Basic info
            </small>
          </div>
          <FieldRow icon="fa-tag" label="Donation name" value={d?.name} />
          <FieldRow icon="fa-cube" label="Unit" value={d?.unit} />
          <FieldRow
            icon="fa-inr"
            label="Amount / quantity"
            value={
              d?.amount != null
                ? `₹ ${Number(d.amount).toLocaleString("en-IN")}`
                : null
            }
          />
        </div>

        {/* Linked trusts */}
        <div className="border rounded">
          <div className="px-3 py-2 border-bottom bg-light">
            <small className="text-uppercase text-muted fw-medium ls-1">
              Linked trusts ({d?.trustDetail?.length ?? 0})
            </small>
          </div>
          <div className="px-3 py-2 d-flex align-items-start gap-2">
            <i className="fa fa-university text-muted mt-1" />
            <div className="d-flex flex-wrap gap-2">
              {d?.trustDetail?.length > 0 ? (
                d.trustDetail.map((t) => (
                  <span
                    key={t.trustId}
                    className="badge rounded-pill border text-primary bg-primary-subtle px-3 py-1"
                  >
                    <i className="fa fa-check me-1" />
                    {t.trustName}
                  </span>
                ))
              ) : (
                <span className="text-muted fst-italic small">
                  No trusts linked
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Temple */}
        {d?.templeDetail && (
          <div className="border rounded">
            <div className="px-3 py-2 border-bottom bg-light">
              <small className="text-uppercase text-muted fw-medium ls-1">
                Temple
              </small>
            </div>
            <FieldRow
              icon="fa-home"
              label="Temple name"
              value={d.templeDetail?.templeName}
            />
            <FieldRow
              icon="fa-map-marker"
              label="City / State"
              value={[d.templeDetail?.city, d.templeDetail?.state]
                .filter(Boolean)
                .join(", ")}
            />
          </div>
        )}

        {/* Meta chips */}
        <div className="d-flex flex-wrap gap-2">
          <StatusChip isActive={d?.isActive} />
          {d?.createdAt && (
            <span className="badge border bg-light text-muted rounded-pill px-3 py-1">
              <i className="fa fa-calendar me-1" />
              Created{" "}
              {new Date(d.createdAt).toLocaleDateString("en-IN", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </span>
          )}
          {d?.updatedAt && (
            <span className="badge border bg-light text-muted rounded-pill px-3 py-1">
              <i className="fa fa-pencil me-1" />
              Updated{" "}
              {new Date(d.updatedAt).toLocaleDateString("en-IN", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </span>
          )}
        </div>
      </ModalBody>

      {/* Footer */}
      <div className="modal-footer">
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => {
            setahoeDataModel(false);
            if (editHandle && d?.accountId) {
              editHandle(d.accountId);
            }
          }}
        >
          <i className="fa fa-pencil me-1" />
          Edit
        </button>
        <button
          className="btn btn-sm btn-primary"
          onClick={() => setahoeDataModel(false)}
        >
          <i className="fa fa-check me-1" />
          Done
        </button>
      </div>
    </Modal>
  );
};

const FieldRow = ({ icon, label, value }) => (
  <div className="d-flex align-items-start gap-2 px-3 py-2 border-bottom">
    <div
      className="border rounded p-1 bg-white mt-1"
      style={{ minWidth: 28, textAlign: "center" }}
    >
      <i className={`fa ${icon} text-muted`} style={{ fontSize: 14 }} />
    </div>
    <div>
      <div className="text-muted" style={{ fontSize: 11 }}>
        {label}
      </div>
      <div className="fw-medium" style={{ fontSize: 13 }}>
        {value || <span className="text-muted fst-italic fw-normal">—</span>}
      </div>
    </div>
  </div>
);

const StatusChip = ({ isActive }) => (
  <span
    className={`badge border rounded-pill px-3 py-1 ${isActive ? "bg-success-subtle text-success border-success" : "bg-secondary-subtle text-secondary"}`}
  >
    <span
      style={{
        width: 7,
        height: 7,
        borderRadius: "50%",
        background: "currentColor",
        display: "inline-block",
        marginRight: 5,
      }}
    />
    {isActive ? "Active" : "Inactive"}
  </span>
);

export default DonationMasterDetailsModel;
